import { FeatureFlags } from '@secretescapes/cauldron';
import { useApplicationState } from './useApplicationState';

export enum BullfinchFeatureFlags {
  extendedPeriodCountdown = 'extended.period.countdown',
  flightsEnabled = 'bullfinch.flights.enabled',
  reviewsEnabled = 'reviews',
  seoTitleTagsEnabled = 'bullfinch.seoTitleTags.enabled',
  bookingFeesEnabled = 'abtest.price.elasticity.variant',
  assistedSalesPromoEnabled = 'assisted.sales.promo.enabled',
  expireImagesEnabled = 'expire.images.enabled',
}

export const useFeatureFlag: (
  featureFlag: FeatureFlags | BullfinchFeatureFlags
) => boolean = featureFlag => {
  const { featureFlags = [] } = useApplicationState();

  return featureFlags.includes(featureFlag);
};
